export default {
    setSessions(state, sessions) {
        state.sessions = sessions;
    },
    setSessionsLoaded(state, status) {
        state.sessionsLoaded = status;
    },
    setSWGroupNumber(state, sw) {
        state.swGroupNumber = sw;
    },
    setTCGroupNumber(state, tc) {
        state.tcGroupNumber = tc;
    },
    setMediaStatus(state, mediaStatus) {
        state.mediaStatus = mediaStatus;
    },
    checkMediaHasDisabled(state) {

        state.mediaStatusHasDisabled = false;
        
        state.mediaStatus.forEach(media => {
            if(!media.status) {
                state.mediaStatusHasDisabled = true;
            }
        });
    },
    setWaitingForMedia(state, activity) {
        state.waitingForMedia[activity] = parseInt(state.waitingForMedia[activity]) + 1;
    },
    setProcessingUploading(state, activity) {
        state.processingUploading[activity] = state.processingUploading[activity] + 1;
    },
    setUploadedCustomerNotified(state, activity) {
        state.uploadedCustomerNotified[activity] = state.uploadedCustomerNotified[activity] + 1;
    },
    setNoGroupAssigned(state, activity) {
        state.noGroupAssigned[activity] = state.noGroupAssigned[activity] + 1;
    },
    clearCount(state) {
        state.waitingForMedia = {
            BJF: 0,
            BJS: 0,
            SJF: 0,
            SJS: 0,
            SW: 0,
            TC: 0
        };

        state.processingUploading = {
            BJF: 0,
            BJS: 0,
            SJF: 0,
            SJS: 0,
            SW: 0,
            TC: 0
        };
        
        state.uploadedCustomerNotified = {
            BJF: 0,
            BJS: 0,
            SJF: 0,
            SJS: 0,
            SW: 0,
            TC: 0
        };

        state.noGroupAssigned = {
            BJF: 0,
            BJS: 0,
            SJF: 0,
            SJS: 0,
            SW: 0,
            TC: 0
        };
    },
    setDiscountCustomer(state, data) {
        state.discountCustomer = data;
    },
    setDiscountTempCustomer(state, data) {
        state.discountTempCustomer = data;
    },
    setDiscountActivities(state, data) {
        state.discountActivities = data;
    },
    setSingleActivity(state, data) {
        let activities = state.discountActivities[data.activity];
        activities.unshift(data);
    },
    setDiscountLogic(state, data) {
        state.discountLogicSettings = data;
    },
    setState(state, {stateName, value}) {
        state[stateName] = value;
    },
    setCustomerLatestSession(state, data) {
        state.customerLatestSession = data;
    },
    setJumpOffStatus(state, data) {
        state.jumpOffStatus = data;
    },
    setJumpOffDescription(state, data) {
        state.jumpOffDescription = data;
    },
    setJumpOffReason(state, data) {
        state.jumpOffReason = data;
    },
    setAssignToGroup(state, data) {
        state.groupMember.push(data);

        state.groupMember.sort(function(a, b) { 
            return a.id - b.id;
        });
    },
    setRemoveToGroup(state, data) {
        state.groupMemberRemoved.push(data);
    },
    setRemoveToCamera(state, data) {
        state.groupCameraRemoved.push(data);
    },
    setAssignToCamera(state, data) {
        state.groupCamera.push(data);
    },
    setErrorMessage(state, data) {
        state.groupErrorMessage.push(data);
    },
    setAssignToTandemCamera(state, data) {
        state.tandemMember.cameras.push(data);
    },
    setAssignToTandemSession(state, data) {
        state.tandemMember.customers.push(data);
    },
    setTandemActivity(state, data) {
        state.tandemActivity = data
    }
}